import { Component, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ShoppingCartService } from '@services/shopping-cart.service';
import { MessageService } from 'primeng/api';
import { FormActionsComponent } from '../form-actions/form-actions.component';

@Component({
  selector: 'vnm-claim-promo-code',
  templateUrl: './claim-promo-code.component.html',
  styleUrls: ['./claim-promo-code.component.scss']
})
export class ClaimPromoCodeComponent {
  @ViewChild(FormActionsComponent) formActions: FormActionsComponent;

  shoppingCart$ = this.shoppingCartService.shoppingCart$;
  promoForm = this.fb.group({
    promoCode: ['']
  });

  constructor(
    private shoppingCartService: ShoppingCartService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private fb: UntypedFormBuilder
  ) {}

  onClaimPromoCode() {
    const { promoCode: code } = this.promoForm.value;

    if (!code) {
      this.formActions.reset({});
      return;
    }

    this.shoppingCartService.claimPromoCodes({ code }).subscribe(
      () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('cart-items.promo-code-claimed')
        });

        this.formActions.reset({});
      },
      (errors) => {
        const { length, [length - 1]: error } = errors;
        this.messageService.add({
          severity: 'error',
          summary: error.message
        });

        this.formActions.reset();
      }
    );
  }
}
